import "./bootstrap";

document.querySelectorAll('nav a').forEach(anchor => {
    anchor.addEventListener('click', function(event) {
        let hash = this.getAttribute('href');
        if (hash.startsWith('/#')) {
            hash = hash.substr(1);
            const targetElement = document.querySelector(hash);

            if (targetElement) {
                event.preventDefault();
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - 60;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    });
});

document.querySelectorAll('.logo_box a').forEach(anchor => {
    anchor.addEventListener('click', function(event) {
        event.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});

$(document).ready(() => {
    let contacts_form = $('#contacts-form');
    if (contacts_form.length > 0) {
        $.ajax({
            method: 'GET',
            url: '/contact/token',
            dataType: 'JSON',
            success: (data) => {
                let token = $('<input type="hidden">');
                token.attr('name', 'token');
                token.attr('value', data.token);
                contacts_form.append(token);
            }
        });

        $('#contacts-form').submit((e) => {
            e.preventDefault();
            var form = $(e.currentTarget);
            form.find('.alert-danger').remove();

            $.ajax({
                url: form.attr('data-target'),
                method: 'POST',
                data: form.serialize(),
                dataType: 'JSON',
                success: function(data) {
                    if (data.status) {
                        form.empty().prepend('<div class="alert alert-info" id="landing-msg-sent"><strong>Messaggio inviato!</strong><br/><p>Verrai contattato al più presto dal nostro supporto commerciale</p></div>');
                    }
                    else {
                        form.prepend('<div class="alert alert-danger text-center"><strong>Messaggio non inviato!</strong><br/><p>Si prega di riprovare</p></div>');
                    }
                }
            });
        });
    }
});
